import { getAccountId } from "../utilities/localStorage";

export const isAutoLogoutFeatureAvailable = () => {
  return ![5665].includes(Number(getAccountId()));
};

export const isNewShopifyFeatureAvailable = () => {
  return [16998].includes(Number(getAccountId()));
};
